import React from 'react';
import LeftNav from 'gatsby-theme-carbon/src/components/LeftNav/LeftNav';

export default props => <LeftNav {...props} homepage={false} theme={'light'} />;